import FullParagraphAndTagsHomepageFirstFoldComponent from "./full-paragraph-and-tags-homepage-first-fold-component";
import FullParagraphAndTagsHomepageFirstFoldConfig from "./full-paragraph-and-tags-homepage-first-fold-config";
import FullParagraphAndTagsHomepageFirstFoldAdvancedConfig from "./full-paragraph-and-tags-homepage-first-fold-advanced-config";

export default {
  FullParagraphAndTagsHomepageFirstFoldComponent,
  FullParagraphAndTagsHomepageFirstFoldConfig,
  FullParagraphAndTagsHomepageFirstFoldAdvancedConfig
};
